import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights(router: Router) {
  if (appInsights) {
    return appInsights;
  }

  const angularPlugin = new AngularPlugin();

  appInsights = new ApplicationInsights({
    config: {
      disableTelemetry: !environment.production,
      connectionString: environment.appInsights.connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      samplingPercentage: 100,
      extensions: [angularPlugin],
      extensionConfig: { [angularPlugin.identifier]: { router } }
    }
  });

  appInsights.loadAppInsights();

  return appInsights;
}

export function getAppInsights() {
  if (!appInsights) {
    console.error('AppInsights not initialized yet.');
    return null;
  }
  return appInsights;
}
